<template>

    <v-container v-if='!loading'>
        <v-row>
            <v-col>
                <h3 class='d-block font-weight-bold flex-grow-1 mb-2'>درخواست سرویس خدمات</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols='12' md='5'>
                <v-card class='mx-auto'>
                    <v-list two-line>

                        <v-list-item-group
                            color='primary'
                        >
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "cleaningService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/cleaning.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['cleaningService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "facilitiesService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/piping.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['facilitiesService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "electericService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/electricWork.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['electericService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "elevatorService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/elevator.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['elevatorService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "CCTVService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/CCTV.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['CCTVService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "coolerService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/cooler.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['coolerService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                            <v-list-item
                                link
                                :to='{name:"RequestServices",params: { service: "faceWashService" }}'
                            >
                                <v-list-item-icon class='mb-2 ml-4'>
                                    <img src='/assets/faceWashService.png' width='32' height='32' />
                                </v-list-item-icon>
                                <v-list-item-title>{{ translate['faceWashService'] }}</v-list-item-title>
                                <v-list-item-icon class='mb-2'>
                                    <v-icon class='float-end'>mdi-chevron-left</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'list',
        methods: {
            ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        data() {
            return {
                loading: true
            };
        },
        async created() {
            await this.setBreadCrumbsTemp({
                key: 'services',
                value: {
                    text: `خدمات`,
                    href: `/apartments/${this.$route.params.apartment_id}/services`
                }
            });
            this.loading = false;
        },
        async updated() {
            await this.showBreadCrumbs(['home', 'apartmentDetail', 'services']);
        },
        computed: {

            ...mapState({
                translate: state => state.translate.fa.service
            })
        }
    };
</script>

<style scoped>

</style>